import { useEffect } from 'react';
import type { BrowserAgentComponent } from 'api/types';
import { getOrCreatePusher } from 'components/App/hooks/useInitPusher';
import { useUpdateConversation } from 'components/App/hooks';
import { useAppDispatch, useAppSelector } from 'hooks';
import { setStreaming } from 'reducers/workflows';
import { selectIsCurrentTabPrimary } from 'persistence/persistenceBetweenTabs';

interface BrowserAgentStepProps {
  setStepSent: (query?: string) => void;
  stepIndex: number;
  widgetComponent: BrowserAgentComponent;
}

export const BrowserAgentStep = ({
  setStepSent,
  widgetComponent,
}: BrowserAgentStepProps) => {
  const dispatch = useAppDispatch();
  const updateConversation = useUpdateConversation();
  const isCurrentTabPrimary = useAppSelector(selectIsCurrentTabPrimary);

  useEffect(() => {
    if (widgetComponent.isSent || !isCurrentTabPrimary) {
      return;
    }

    const channelId = widgetComponent.component_fields.channel_id;

    const pusher = getOrCreatePusher();

    dispatch(setStreaming(true));

    const channel = pusher.subscribe(channelId);

    channel.bind('browser-agent-success', () => {
      dispatch(setStreaming(false));
      setStepSent();
      updateConversation({}, { isContinueAutoflowIntent: true });
    });

    channel.bind('browser-agent-error', () => {
      dispatch(setStreaming(false));
      setStepSent();
      updateConversation({}, { isContinueAutoflowIntent: true });
    });

    return () => {
      channel.unbind_all();
      pusher.unsubscribe(channelId);
      dispatch(setStreaming(false));
    };
  }, [
    dispatch,
    isCurrentTabPrimary,
    setStepSent,
    updateConversation,
    widgetComponent,
  ]);

  return null;
};
